export default __webpack_public_path__ + "static/media/ssc-hxln-shengshi.0976cd00.png";